"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { TrendingUp, ChartPie, Target, ArrowRight } from "lucide-react";
export default function FinancialConsulting() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const consultingServices = [{
    id: 1,
    icon: TrendingUp,
    title: "Business Growth Strategy",
    description: "Strategic financial planning to accelerate your business growth and maximize profitability through data-driven insights and market analysis.",
    features: ["Growth forecasting", "Market positioning", "Investment planning"]
  }, {
    id: 2,
    icon: ChartPie,
    title: "Financial Analysis & Reporting",
    description: "Comprehensive financial analysis and custom reporting solutions to help you understand your business performance and make informed decisions.",
    features: ["KPI dashboards", "Performance metrics", "Trend analysis"]
  }, {
    id: 3,
    icon: Target,
    title: "Strategic Planning",
    description: "Long-term financial planning and strategic advisory to help you achieve your business objectives and navigate complex financial landscapes.",
    features: ["Budget optimization", "Risk assessment", "Goal setting"]
  }];
  return <section id="financialconsulting" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6">
        <div ref={headerRef} className={`text-center mb-12 md:mb-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-foreground mb-4 !text-5xl !font-bold">Financial Consulting</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Expert financial consulting services tailored to your business needs. We help you make informed decisions and achieve sustainable growth.
          </p>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {consultingServices.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className={`card hover-lift bg-surface border border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: cardsVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardHeader>
                  <div className="mb-4 inline-flex items-center justify-center size-12 rounded-[var(--radius-md)] bg-primary/10 text-primary">
                    <Icon className="size-6" />
                  </div>
                  <CardTitle className="text-foreground">{service.title}</CardTitle>
                  <CardDescription className="text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => <li key={idx} data-index={idx} className="flex items-start gap-2 text-sm text-foreground/80">
                        <ArrowRight className="size-4 text-primary mt-0.5 shrink-0" />
                        <span>{feature}</span>
                      </li>)}
                  </ul>
                  <Link to="#" className="inline-block w-full">
                    
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className={`mt-12 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-300 ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <p className="text-muted-foreground mb-6">Need personalised financial consulting for your business?</p>
          <Link to="/team-and-contact#contact-us" className="inline-block">
            <Button className="btn-primary">
              Schedule a Consultation
              <ArrowRight className="size-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}